// Loads a provider's sign-in script (Google Identity Services, Sign in with Apple JS) once per page. These are the
// only third-party scripts the console runs, and only on the sign-in screens, only when the provider is on.

const loads = new Map<string, Promise<void>>();

export function loadScript(src: string, timeoutMs = 15_000): Promise<void> {
  const existing = loads.get(src);
  if (existing) return existing;
  const promise = new Promise<void>((resolve, reject) => {
    const el = document.createElement('script');
    el.src = src;
    el.async = true;
    el.defer = true;
    const timer = window.setTimeout(() => {
      reject(new Error(`Timed out loading ${src}`));
    }, timeoutMs);
    el.onload = () => {
      window.clearTimeout(timer);
      resolve();
    };
    el.onerror = () => {
      window.clearTimeout(timer);
      reject(new Error(`Couldn't load ${src}`));
    };
    document.head.appendChild(el);
  });
  // A failed load (offline, blocked) may be retried on the next attempt.
  promise.catch(() => {
    loads.delete(src);
  });
  loads.set(src, promise);
  return promise;
}
